import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import { ScrollToTop } from '@/components/scroll-to-top'
import { ThemeProvider } from '@/contexts/theme-context'
import { SubscriptionProvider } from '@/contexts/subscription-context'
import { SmartRedirect } from '@/components/subscription-guard'
import { ColorSchemeTester } from '@/components/color-scheme-tester'

// Pages
import { HomePage } from '@/routes/home'
import { ArticleDetailPage } from '@/routes/article-detail'
import { ProviderPage } from '@/routes/provider'
import { TagsPage } from '@/routes/tags'
import { BookmarksPage } from '@/routes/bookmarks'
import { TrendingPage } from '@/routes/trending'
import { SearchPage } from '@/routes/search'
import { TodayPage } from '@/routes/today'
import { FAQPage } from '@/routes/faq'
import { PurchasePolicyPage } from '@/routes/purchase-policy'
import { DashboardPage } from '@/routes/dashboard'
import { PricingPage } from '@/routes/pricing'
import { LoginPage } from '@/routes/auth/login'
import { SignupPage } from '@/routes/auth/signup'
import { VerifyEmailPage } from '@/routes/auth/verify-email'
import { NotFoundPage } from '@/routes/not-found'

function App() {
  return (
    <ThemeProvider>
      <SubscriptionProvider>
        <ScrollToTop />
        <SmartRedirect />
        <Routes>
        {/* Main Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/posts/:slug" element={<ArticleDetailPage />} />
        <Route path="/provider/:slug" element={<ProviderPage />} />
        <Route path="/tags/:slug" element={<TagsPage />} />
        <Route path="/bookmarks" element={<BookmarksPage />} />
        <Route path="/trending" element={<TrendingPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/today" element={<TodayPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/article/purchases-policy" element={<PurchasePolicyPage />} />
        
        {/* Dashboard Routes */}
        <Route path="/dashboard/*" element={<DashboardPage />} />
        
        {/* Pricing & Auth */}
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/email/verify" element={<VerifyEmailPage />} />
        
        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      
      {/* Toast notifications */}
      <Toaster position="top-right" richColors />
      
      {/* Color Scheme Tester - Controlled by VITE_ENABLE_COLOR_TESTER env variable */}
      {import.meta.env.VITE_ENABLE_COLOR_TESTER === 'true' && <ColorSchemeTester />}
      </SubscriptionProvider>
    </ThemeProvider>
  )
}

export default App
